export var PaymentMethods;
(function (PaymentMethods) {
    PaymentMethods["CreditDebitCard"] = "Credit/Debit Card";
    PaymentMethods["DirectDebit"] = "Direct Debit";
    PaymentMethods["ElectronicBankTransfer"] = "Electronic Bank Transfer";
})(PaymentMethods || (PaymentMethods = {}));
